// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"eabad571","651":"66652673","811":"4f564df3"}[chunkId] + ".chunk.js";
};